import styled, { css } from "styled-components";
import { Device } from "../../../../styles/screenSizes";

interface ImgProps {
  leftAlignOnMobile?: boolean;
  customWidthOnMobile?: number;
}

interface LogoProps {
  leftAlignOnMobile?: boolean;
  customWidthOnMobile?: number;
}

export const StyledImg = styled.img<ImgProps & { clickable?: boolean }>`
  height: 50px;
  width: 160px;
  object-fit: contain;
  object-position: left;

  ${({ customWidthOnMobile }) =>
    customWidthOnMobile &&
    css`
      @media ${Device.mobile} {
        width: ${customWidthOnMobile}px;
      }
    `};

  ${({ clickable }) => clickable && `cursor: pointer`};
`;

export const StyledLogo = styled.div<LogoProps>`
  display: flex;
  align-items: center;
  height: inherit;

  ${({ leftAlignOnMobile }) =>
    !leftAlignOnMobile &&
    css`
      @media ${Device.mobile} {
        /* center the logo https://stackoverflow.com/a/25776315 */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `};
`;

export const StyledAnchor = styled.a`
  display: flex;
  align-items: center;
`;
